<template>
    <div v-if="showNoInternet" class="text-center p-3">
        <NoWifiIcon />
        <p>No internet connection. Please check your network.</p>
    </div>
    <div v-else-if="showNoDeviceSection == true">
        <div class="container">
            <div class="main-container">
                <div class="profile-section mb-2 sticky-top">
                    <div class="text-left">
                        <span>
                            <a href="javascript:void(0)" class="text-black">
                                <ThreeLineMenuIcon />

                            </a>&nbsp; 
                            <a href="javascript:void(0)" class="text-black" @click="$router.push({ path: '/kids-device'})">
                                <img :src="logo" height="19px" />
                            </a>
                        </span>
                        <div class="float-right">
                            <a href="javascript:void(0)" class="text-black">
                                <span class="unread-notification" v-if="unReadNotificationTotal > 0"></span>
                                <NotificationBellIcon /> 
                            </a>
                        </div>
                    </div>
                </div>
                <div class="profile-section" v-if="useDefaultPassword == 'true'">
                    <div class="alert alert-warning" role="alert">
                        You are currently using the default password. <a href="javascript:void(0)" @click="$router.push({ path: '/change-password'})" >Click here</a> to update your password for enhanced security.
                    </div>
                </div>
                <div class="profile-section mb-2">
                    <div class="text-left">
                        No devices have been added yet.
                    </div>
                    <!-- New Profile Button -->
                    <button type="button" class="btn btn-primary mb-2" :style="{ 'border-radius': '30px', width: '50%' }" @click="$router.push({ path: '/parent-profile' })">Go To Profile</button>

                    <!-- Go To Payment History Button -->
                    <button type="button" class="btn btn-success mb-2" :style="{ 'border-radius': '30px', width: '50%' }" @click="$router.push({ path: '/payment-history' })">Go To Payment History</button>

                    <!-- Log Out Button -->
                    <button type="button" class="btn btn-danger" :style="{ 'border-radius': '30px', width: '50%' }" @click="doLogout()">Log out</button>
                </div>

            </div>
        </div>
    </div>
    <div v-else>
        <KidHeader v-if="currentProfile" :style="{ 'max-width': '575px', 'margin': '0 auto', 'padding-left': '15px', 'padding-right': '15px' }" :profileId="currentProfile._id" :serialNumber="currentProfile.deviceDetail.serialNumber" />
        <div class="container">
            <div class="main-container">
                
                <div>
                    <div class="inline-alert inline-alert--warning mb-3" v-if="currentProfile && currentProfile.deviceLimitReached == true && !dismissedAlerts.deviceLimit">
                        <div class="inline-alert__icon">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M12 9V13M12 17H12.01M10.29 3.86L1.82 18C1.64 18.3 1.55 18.65 1.55 19C1.55 20.1 2.45 21 3.55 21H20.45C21.55 21 22.45 20.1 22.45 19C22.45 18.65 22.36 18.3 22.18 18L13.71 3.86C13.17 2.9 11.83 2.9 11.29 3.86H10.29Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="inline-alert__body">
                            <span class="inline-alert__title">Device limit reached</span>
                            <span class="inline-alert__msg">All applications have been disabled. Please increase the device limit to re-enable them now; otherwise they will be automatically re-enabled when the day changes.</span>
                        </div>
                        <button class="inline-alert__close" @click="dismissedAlerts.deviceLimit = true" aria-label="Dismiss">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </button>
                    </div>

                    <div class="inline-alert inline-alert--warning mb-3" v-if="useDefaultPassword == 'true' && !dismissedAlerts.defaultPassword">
                        <div class="inline-alert__icon">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M12 8V12M12 16H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="inline-alert__body">
                            <span class="inline-alert__title">Default password in use</span>
                            <span class="inline-alert__msg">You are currently using the default password. <a href="javascript:void(0)" @click="$router.push({ path: '/change-password' })">Tap here</a> to update it for enhanced security.</span>
                        </div>
                        <button class="inline-alert__close" @click="dismissedAlerts.defaultPassword = true" aria-label="Dismiss">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </button>
                    </div>

                    <div class="inline-alert inline-alert--warning mb-3" v-if="currentProfile && currentProfile?.deviceDetail?.protectionEnabled == 2 && !dismissedAlerts.fullAccess">
                        <div class="inline-alert__icon">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M12 22S20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M12 8V12M12 16H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="inline-alert__body">
                            <span class="inline-alert__title">Full access enabled</span>
                            <span class="inline-alert__msg">Kid may be able to bypass security restrictions, potentially exposing the system to unauthorized actions or data access. <a href="javascript:void(0)" @click="$router.push({ path: '/global-settings', query: { profileId: this.currentProfile?._id, serialNumber: this.currentProfile?.deviceDetail?.serialNumber } })">Tap here</a> to change this setting.</span>
                        </div>
                        <button class="inline-alert__close" @click="dismissedAlerts.fullAccess = true" aria-label="Dismiss">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </button>
                    </div>
                </div>
                <!-- Subscription expiry warnings — one banner per expired subscription -->
                <div
                    v-for="warning in subscriptionWarnings"
                    :key="warning._id"
                    class="profile-section mb-2"
                >
                    <div class="subscription-warning-card">
                        <!-- Top row: icon + title + badge -->
                        <div class="d-flex justify-content-between align-items-center mb-1">
                            <div class="d-flex align-items-center">
                                <span class="subscription-warning-icon">
                                    <i class="fas fa-exclamation"></i>
                                </span>
                                <span class="subscription-warning-title">
                                    Subscription Expired
                                </span>
                            </div>
                            <span class="subscription-warning-badge">
                                Action Required
                            </span>
                        </div>

                        <!-- Device + expiry info -->
                        <div class="subscription-warning-body">
                            <div class="subscription-warning-device" v-if="warning.deviceLabel || warning.serialNumber">
                                <span v-if="warning.deviceLabel">
                                    <i class="fas fa-tablet-alt subscription-warning-device-icon"></i>
                                    <b>{{ warning.deviceLabel }}</b>
                                </span>
                                <span v-if="warning.serialNumber" class="subscription-warning-serial">
                                    · {{ warning.serialNumber }}
                                </span>
                            </div>
                            <div class="subscription-warning-expiry">
                                <i class="fas fa-calendar-times"></i>
                                Expired on {{ new Date(warning.expiryAt).toLocaleDateString("en-US", $dateOptions) }}
                            </div>

                            <!-- Warning message -->
                            <div class="subscription-warning-message">
                                <i class="fas fa-shield-alt"></i>
                                Your child's device protection is currently inactive. Renew now to restore full parental controls and keep their device safe.
                            </div>

                            <!-- Renew button -->
                            <button
                                type="button"
                                class="subscription-warning-btn"
                                :class="{ 'subscription-warning-btn--loading': renewingSubscriptionId === warning.subscriptionId }"
                                :disabled="renewingSubscriptionId === warning.subscriptionId"
                                @click="renewSubscription(warning.subscriptionId)"
                            >
                                <span v-if="renewingSubscriptionId === warning.subscriptionId">
                                    <i class="fa fa-spinner fa-spin mr-1"></i> Processing...
                                </span>
                                <span v-else>
                                    <i class="fas fa-redo mr-1"></i> Renew Subscription
                                </span>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="kid-card" v-if="currentProfile && currentProfile.deviceDetail">
                    <!-- Top row: avatar + name + edit -->
                    <div class="kid-card__header">
                        <div class="kid-card__avatar">
                            <img v-if="existingProfilePic" :src="existingProfilePic" class="rounded-circle" alt="Profile Pic" width="44" height="44">
                            <DefaultProfilePicIcon v-else />
                        </div>
                        <div class="kid-card__info">
                            <div class="kid-card__name-row">
                                <a class="kid-card__name" href="javascript:void(0)" @click="openKidsListModal()" v-if="currentProfile">
                                    {{ currentProfile.profile_name }}
                                    <DownArrowIcon />
                                </a>

                                <!-- Version + warning moved here on the right -->
                                <div class="kid-card__meta">
                                    <span class="kid-card__version" v-if="!currentProfile.deviceDetail.appVersion">
                                        {{ currentProfile.deviceDetail.hardwareInfo.brand }} {{ currentProfile.deviceDetail.hardwareInfo.model }}
                                    </span>
                                    <span class="kid-card__version" v-else>V{{ currentProfile.deviceDetail.appVersion }}</span>

                                    <a href="javascript:void(0)" @click="openKidsAppStatusPopup()" v-if="currentProfile.deviceDetail.kidsApplicationStatus != 'Healthy'" class="kid-card__warning">
                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke="#dc2626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <line x1="12" y1="9" x2="12" y2="13" stroke="#dc2626" stroke-width="2" stroke-linecap="round"/>
                                            <line x1="12" y1="17" x2="12.01" y2="17" stroke="#dc2626" stroke-width="2" stroke-linecap="round"/>
                                        </svg>
                                    </a>
                                </div>

                                <a class="kid-card__edit" href="javascript:void(0)" @click="openKidsprofilePageModal()" v-if="currentProfile">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>

                    <!-- Action pills row -->
                    <div class="kid-card__actions">

                        <!-- Sleep mode -->
                        <div class="kid-action-pill" v-if="currentProfile && currentProfile.deviceDetail" @click="openSleepModeModal()">
                            <div class="kid-action-pill__icon" :class="{
                                'kid-action-pill__icon--active': currentProfile.deviceDetail.sleepModeFcmDetail && currentProfile.deviceDetail.sleepModeFcmDetail.isDeviceAcknowledge === true && currentProfile.sleepMode == true,
                                'kid-action-pill__icon--warning': currentProfile.deviceDetail.sleepModeFcmDetail && currentProfile.deviceDetail.sleepModeFcmDetail.isDeviceAcknowledge !== true
                            }">
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                                    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div class="kid-action-pill__body">
                                <span class="kid-action-pill__label">Sleep</span>
                                <label class="kid-action-switch" @click.stop>
                                    <input type="checkbox" v-model="sleepMode" @click="toggleSleepMode()">
                                    <span class="kid-action-switch__track"></span>
                                </label>
                            </div>
                        </div>

                        <!-- WiFi status -->
                        <div class="kid-action-pill">
                            <div class="kid-action-pill__icon" :class="currentProfile.deviceDetail.wifiConnected ? 'kid-action-pill__icon--active' : 'kid-action-pill__icon--off'">
                                <WifiIcon v-if="currentProfile && currentProfile.deviceDetail.wifiConnected == true" />
                                <NoWifiIcon v-else />
                            </div>
                            <div class="kid-action-pill__body">
                                <span class="kid-action-pill__label">Net</span>
                                <span class="kid-action-pill__status" :class="currentProfile.deviceDetail.wifiConnected ? 'kid-action-pill__status--on' : 'kid-action-pill__status--off'">
                                    {{ currentProfile.deviceDetail.wifiConnected ? 'Online' : 'Offline' }}
                                </span>
                            </div>
                        </div>

                        <!-- Screen capture -->
                        <div class="kid-action-pill" :class="{ 'kid-action-pill--disabled': !currentProfile.deviceDetail.wifiConnected }">
                            <router-link v-if="currentProfile.deviceDetail.wifiConnected"
                                :to="{ path: '/device-screenshots', query: { profileId: currentProfile._id, serialNumber: currentProfile.deviceDetail.serialNumber, captureScreen: true }}"
                                class="kid-action-pill__link">
                                <div class="kid-action-pill__icon kid-action-pill__icon--active">
                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                                        <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                        <circle cx="12" cy="13" r="4" stroke="currentColor" stroke-width="1.8"/>
                                    </svg>
                                </div>
                                <div class="kid-action-pill__body">
                                    <span class="kid-action-pill__label">Screen</span>
                                    <span class="kid-action-pill__status kid-action-pill__status--on">Capture</span>
                                </div>
                            </router-link>
                            <template v-else>
                                <div class="kid-action-pill__icon kid-action-pill__icon--off">
                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                                        <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                        <circle cx="12" cy="13" r="4" stroke="currentColor" stroke-width="1.8"/>
                                    </svg>
                                </div>
                                <div class="kid-action-pill__body">
                                    <span class="kid-action-pill__label">Screen</span>
                                    <span class="kid-action-pill__status kid-action-pill__status--off">Offline</span>
                                </div>
                            </template>
                        </div>

                        <!-- Battery -->
                        <div class="kid-action-pill" v-if="currentProfile.deviceDetail.batteryPercentage">
                            <div class="kid-action-pill__icon" :class="{
                                'kid-action-pill__icon--active': currentProfile.deviceDetail.batteryPercentage > 20,
                                'kid-action-pill__icon--danger': currentProfile.deviceDetail.batteryPercentage <= 20
                            }">
                                <FullBatteryIcon v-if="currentProfile.deviceDetail.batteryPercentage > 80" />
                                <HalfBatteryIcon v-else-if="currentProfile.deviceDetail.batteryPercentage >= 20" />
                                <LowBatteryIcon v-else />
                            </div>
                            <div class="kid-action-pill__body">
                                <span class="kid-action-pill__label">Battery</span>
                                <span class="kid-action-pill__status" :class="{
                                    'kid-action-pill__status--on': currentProfile.deviceDetail.batteryPercentage > 20,
                                    'kid-action-pill__status--off': currentProfile.deviceDetail.batteryPercentage <= 20
                                }">{{ currentProfile.deviceDetail.batteryPercentage }}%</span>
                            </div>
                        </div>

                    </div>

                    <!-- Collapse panels — unchanged -->
                    <div class="collapse footer" v-if="currentProfile" id="kidsAppProtectionPopup">
                        <div class="card">
                            <div class="card-body">
                                <h6 class="text-black">
                                    <b>Message</b> <a href="javascript:void(0)" class="text-black" @click="closeKidsAppProtactionPopup()"><i class="fas fa-times float-right pt-1 pr-2"></i></a>
                                </h6><hr>
                                <p class="text-black" v-if="kidsAppProtectionStatus == false"><b>Settings on Device:</b> Kids may be able to change device settings. To enhance security, please enable here the APP Setting Protection Status. You might need to disable it, when the child needs to access settings like adding additional WLANs.</p>
                                <b>App Protection Status</b>&nbsp;
                                <label class="switch">
                                    <input type="checkbox" v-model="kidsAppProtectionStatus">
                                    <span class="slider round"></span>
                                </label>
                                <div class="profile-section text-center p-3">
                                    <button type="button" class="btn btn-primary" :style="{ 'background': '#0073EE', 'border-radius': '20px' }" @click="updateAppProtectionStatus()" :disabled="isDisabled">Save<span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span></button>&nbsp;
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="collapse footer" v-if="currentProfile" id="kidsAppStatusPopup">
                        <div class="card">
                            <div class="card-body">
                                <h6 class="text-black">
                                    <b>Error Message</b> <a href="javascript:void(0)" class="text-black" @click="closeKidsAppStatusPopup()"><i class="fas fa-times float-right pt-1 pr-2"></i></a>
                                </h6><hr>
                                <p class="text-black">Following permissions are missing:</p>
                                <p class="text-black"><b>{{ currentProfile.deviceDetail.additionalData }}</b></p>
                                <p class="text-black">Please launch Wingio app on kids device and grant the requested permissions.</p>
                            </div>
                        </div>
                    </div>

                    <div class="collapse footer" v-if="currentProfile" id="sleepModePopup">
                        <div class="card">
                            <div class="card-body">
                                <h6 class="text-black">
                                    <b>Sleep Mode</b> <a href="javascript:void(0)" class="text-black" @click="closeSleepMode()"><i class="fas fa-times float-right pt-1 pr-2"></i></a>
                                </h6><hr>
                                <p class="text-black">When Sleep Mode is enabled, the child cannot use the device until Sleep Mode is turned off.</p>
                            </div>
                        </div>
                    </div>

                    <div class="collapse footer" id="navbarToggleExternalContent">
                        <div class="card">
                            <div class="card-body">
                                <p class="text-muted">
                                    <b>Choose Kids Profile</b>
                                    <span class="float-right"><a class="text-black" href="javascript:void(0)" @click="closeKidsScreen()"><i class="fas fa-times"></i></a></span>
                                </p>
                                <div class="ScrollStyle">
                                    <div class="profile-section mb-2" v-for="profile in profileList" :key="profile._id">
                                        <div class="row p-1" :class="{'opacity-25': profile.totalDevices == 0}">
                                            <div class="col-3 text-center">
                                                <img v-if="profile.deviceDetail && profile.deviceDetail.kidProfilePic" :src="profile.deviceDetail.kidProfilePic" class="rounded-circle" alt="Profile Pic" width="50" height="50">
                                                <DefaultProfilePicIcon v-else />
                                            </div>
                                            <div class="col kids-name">
                                                <span class="pl-1" :style="{ 'font-size': '14px' }" v-if="profile.totalDevices > 0">
                                                    <a class="text-black" href="javascript:void(0)" @click="switchProfile(profile)">&nbsp;{{ profile.profile_name }}</a>
                                                </span>
                                                <span class="pl-2" v-else>&nbsp;{{ profile.profile_name }}</span>
                                                <p v-if="profile.deviceDetail"><small class="pl-2">{{ profile.deviceDetail.serialNumber }}</small></p>
                                            </div>
                                            <div class="col float-right">
                                                <div class="float-right">
                                                    <span :style="{ 'font-size': '12px' }">
                                                        <WifiIcon v-if="profile.totalDevices > 0 && profile.deviceDetail.wifiConnected == true" />
                                                        <NoWifiIcon v-else />
                                                    </span>&nbsp;
                                                    <span v-if="profile.deviceDetail && profile.deviceDetail.batteryPercentage" :style="{ 'font-size': '12px' }">{{ profile.deviceDetail.batteryPercentage }}%
                                                        <HalfBatteryIcon v-if="profile.deviceDetail.batteryPercentage >= 20 && profile.deviceDetail.batteryPercentage <= 80" />
                                                        <FullBatteryIcon v-else-if="profile.deviceDetail.batteryPercentage > 80" />
                                                        <LowBatteryIcon v-else />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="collapse footer modal-section" v-if="currentProfile" id="kidsProfilePage">
                        <div class="edit-panel">
                            <!-- Header -->
                            <div class="edit-panel__header">
                                <span class="edit-panel__title">Update Kid's Profile</span>
                                <button class="edit-panel__close" @click="closeProfilePage()">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                                    </svg>
                                </button>
                            </div>

                            <form @submit.prevent="submitKidDetails">

                                <!-- Photo upload -->
                                <div class="edit-panel__photo-section" v-if="!hideGoogleLogin">
                                    <div class="edit-panel__avatar">
                                        <img v-if="newProfilePic" :src="newProfilePic" class="edit-panel__avatar-img" alt="New photo" />
                                        <img v-else-if="existingProfilePic" :src="existingProfilePic" class="edit-panel__avatar-img" alt="Kid photo" />
                                        <div v-else class="edit-panel__avatar-placeholder">
                                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                                                <circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="1.7"/>
                                                <path d="M4 20c0-3.1 3.6-6 8-6s8 2.9 8 6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
                                            </svg>
                                        </div>
                                        <!-- Camera overlay -->
                                        <label for="photoInput" class="edit-panel__avatar-overlay">
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                                <circle cx="12" cy="13" r="4" stroke="white" stroke-width="1.8"/>
                                            </svg>
                                        </label>
                                    </div>
                                    <div class="edit-panel__photo-hint">
                                        <span class="edit-panel__photo-label">Kid's Photo</span>
                                        <label for="photoInput" class="edit-panel__photo-btn">
                                            {{ newProfilePic ? 'Change photo' : (existingProfilePic ? 'Replace photo' : 'Upload photo') }}
                                        </label>
                                    </div>
                                    <input
                                        id="photoInput"
                                        type="file"
                                        accept="image/*"
                                        @change="handleFileUpload"
                                        style="display: none;"
                                    />
                                </div>

                                <div class="edit-panel__fields">
                                    <!-- Kid's Name -->
                                    <div class="edit-field">
                                        <label class="edit-field__label" for="kidName">Kid's Name</label>
                                        <input
                                            type="text"
                                            class="edit-field__input"
                                            id="kidName"
                                            v-model="kidName"
                                            placeholder="Enter kid's name"
                                            required
                                        />
                                    </div>

                                    <!-- Birth Month -->
                                    <div class="edit-field">
                                        <label class="edit-field__label" for="birthMonth">Birth Month</label>
                                        <div class="edit-field__select-wrap">
                                            <select class="edit-field__input" id="birthMonth" v-model.number="birthMonth" required>
                                                <option disabled value="">Select month</option>
                                                <option v-for="month in months" :key="month.value" :value="month.value">{{ month.name }}</option>
                                            </select>
                                            <svg class="edit-field__select-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
                                                <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                    </div>

                                    <!-- Birth Year -->
                                    <div class="edit-field">
                                        <label class="edit-field__label" for="birthYear">Birth Year</label>
                                        <input
                                            type="number"
                                            class="edit-field__input"
                                            id="birthYear"
                                            v-model="birthYear"
                                            :min="2000"
                                            :max="new Date().getFullYear()"
                                            placeholder="e.g. 2015"
                                            required
                                        />
                                    </div>
                                </div>

                                <!-- Save button -->
                                <div class="edit-panel__footer">
                                    <button
                                        type="submit"
                                        class="edit-panel__save-btn"
                                        @click="updateKidProfileDetail()"
                                        :disabled="isDisabled"
                                    >
                                        <span v-if="isDisabled">
                                            <i class="fa fa-spinner fa-spin"></i> Saving...
                                        </span>
                                        <span v-else>Save Changes</span>
                                    </button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>

                <div class="location-card" v-if="currentProfile && currentProfile.deviceDetail && currentProfile.deviceDetail.lastDeviceLocation">
    
                    <!-- Header row -->
                    <div class="location-card__header" @click="toggleMap()">
                        <div class="location-card__icon">
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                <circle cx="12" cy="10" r="3" stroke="currentColor" stroke-width="1.8"/>
                            </svg>
                        </div>
                        <div class="location-card__info">
                            <span class="location-card__label">Last Location</span>
                            <span class="location-card__coords" v-if="currentProfile.deviceDetail.lastDeviceLocation.address">
                                {{ currentProfile.deviceDetail.lastDeviceLocation.address }}
                            </span>
                            <span class="location-card__coords" v-else-if="currentProfile.deviceDetail.lastDeviceLocation.latitude && currentProfile.deviceDetail.lastDeviceLocation.longitude">
                                {{ parseFloat(currentProfile.deviceDetail.lastDeviceLocation.latitude).toFixed(4) }},
                                {{ parseFloat(currentProfile.deviceDetail.lastDeviceLocation.longitude).toFixed(4) }}
                            </span>
                            <span class="location-card__coords" v-else>
                                Location unavailable
                            </span>
                        </div>
                        <div class="location-card__actions-row" @click.stop>
                            <!-- Google Maps shortcut -->
                            
                                <a class="location-card__action-btn"
                                :href="`https://www.google.com/maps?q=${currentProfile.deviceDetail.lastDeviceLocation.latitude},${currentProfile.deviceDetail.lastDeviceLocation.longitude}`"
                                target="_blank"
                                title="Open in Google Maps"
                            >
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="#ea4335" stroke="#ea4335" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <circle cx="12" cy="9" r="2.5" fill="white"/>
                                </svg>
                            </a>
                            <!-- Fetch latest location -->
                            <!--<button
                                class="location-card__action-btn"
                                :class="{ 'location-card__action-btn--loading': fetchingLocation }"
                                :disabled="!currentProfile.deviceDetail.wifiConnected || fetchingLocation"
                                @click="fetchLatestLocation()"
                                title="Fetch latest location"
                            >
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" :class="{ 'location-card__spin': fetchingLocation }">
                                    <path d="M23 4v6h-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>-->
                        </div>
                        <div class="location-card__chevron" :class="{ 'location-card__chevron--open': showMap }">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>

                    <!-- Expanded body -->
                    <div class="location-card__body" v-if="showMap">

                        <!-- Timestamp + address -->
                        <div class="location-card__meta">
                            <div class="location-card__timestamp" v-if="currentProfile.deviceDetail.lastDeviceLocation.deviceDateTime">
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" style="flex-shrink:0">
                                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"/>
                                    <path d="M12 6v6l4 2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                                </svg>
                                {{ formatDateTime(currentProfile.deviceDetail.lastDeviceLocation.deviceDateTime) }}
                            </div>
                            <!--<div class="location-card__address">
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" style="flex-shrink:0; color:#6b7280;">
                                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                Hemel Hempstead, Hertfordshire, England, UK
                            </div>-->
                        </div>

                        <!-- Map -->
                        <div class="location-card__map">
                            <iframe
                                v-if="iframeMapUrl"
                                width="100%"
                                height="240"
                                frameborder="0"
                                scrolling="no"
                                marginheight="0"
                                marginwidth="0"
                                :src="iframeMapUrl"
                                style="display: block;"
                            ></iframe>
                        </div>

                        <!-- Location history -->
                        <div class="location-history">
                            <button class="location-history__toggle" @click="showLocationHistory = !showLocationHistory">
                                <span class="location-history__title">Recent History</span>
                                <svg
                                    width="14" height="14" viewBox="0 0 24 24" fill="none"
                                    :style="{ transform: showLocationHistory ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }"
                                >
                                    <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>

                            <div v-if="showLocationHistory">
                                <!-- Loader -->
                                <div v-if="locationHistoryLoading" class="location-history__loader">
                                    <i class="fa fa-spinner fa-spin"></i>
                                    <span>Loading history...</span>
                                </div>

                                <!-- Empty -->
                                <div v-else-if="!locationHistory.length" class="location-history__empty">
                                    No recent locations found
                                </div>

                                <!-- List -->
                                <div v-else class="location-history__list">
                                    <div class="location-history__item" v-for="(entry, index) in locationHistory" :key="index">
                                        <div class="location-history__dot-wrap">
                                            <div class="location-history__dot" :class="index === 0 ? 'location-history__dot--active' : ''"></div>
                                            <div class="location-history__line" v-if="index < locationHistory.length - 1"></div>
                                        </div>
                                        <div class="location-history__info">
                                            <span class="location-history__addr">{{ entry.address }}</span>
                                            <span class="location-history__time">{{ entry.time }}</span>
                                        </div>
                                        
                                            <a :href="`https://www.google.com/maps?q=${entry.latitude},${entry.longitude}`"
                                            target="_blank"
                                            class="location-history__map-link"
                                            @click.stop
                                        >
                                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                                                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="#ea4335" stroke="#ea4335" stroke-width="0.5"/>
                                                <circle cx="12" cy="9" r="2.5" fill="white"/>
                                            </svg>
                                        </a>
                                    </div>
                                </div>

                                <button class="location-history__view-all" @click="$router.push({ path: '/location-history', query: { profileId: currentProfile._id, serialNumber: currentProfile.deviceDetail.serialNumber } })">
                                    View All History
                                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                        <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                      
                <div class="collapse footer" id="ScreenTimeRecommendationPopup">
                    <div class="card">
                        <div class="card-body">
                            <h6 class="text-black">
                                <b>Screen Time Recommendation</b> <a href="javascript:void(0)" class="text-black" @click="closeScreenTimeRecommendation()"><i class="fas fa-times float-right pt-1 pr-2"></i></a>
                            </h6><hr>
                            <p class="text-black" v-html="kidScreenTimeRecommendation"></p>
                            <p class="text-black">Excemption of this screen time is to use the phone only for music and audiobooks - so for listening in the background and not active screen time. Screen time is only monitored while being active on the screen. Listening in the background is not getting tracked and is not included in the daily limits.</p>
                        </div>
                    </div>
                </div>
                
                <div class="activity-section">
                    <!-- Activity header + date nav -->
                    <div class="activity-header">
                        <div class="activity-header__top">
                            <h5 class="activity-header__title">Activity</h5>
                            <div class="activity-header__toggle">
                                <button
                                    class="activity-toggle-btn"
                                    :class="{ 'activity-toggle-btn--active': filterType === 'Day' }"
                                    @click="changeFilterType('Day')"
                                >Day</button>
                                <button
                                    class="activity-toggle-btn"
                                    :class="{ 'activity-toggle-btn--active': filterType === 'Week' }"
                                    @click="changeFilterType('Week')"
                                >Week</button>
                            </div>
                        </div>

                        <div class="activity-nav" :data-filter-type="filterType">
                            <button class="activity-nav__arrow" @click="previousDate()" aria-label="Previous">
                                <ArrowLeftIcon />
                            </button>
                            <span class="activity-nav__date">{{ formattedDate }}</span>
                            <button class="activity-nav__arrow" @click="nextDate()" aria-label="Next">
                                <ArrowRightIcon />
                            </button>
                            <div class="activity-nav__cal date-picker-wrapper">
                                <label for="datePickerInput" class="date-picker-label" aria-label="Pick date">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <rect x="3" y="4" width="18" height="18" rx="3" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M16 2v4M8 2v4M3 10h18" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </label>
                                <input
                                    id="datePickerInput"
                                    ref="datePicker"
                                    type="date"
                                    v-model="selectedDate"
                                    @change="onDateChange"
                                    class="date-picker-input"
                                />
                            </div>
                        </div>
                    </div>

                    <!-- Screen time card -->
                    <div class="screentime-card">
                        <div class="screentime-card__header">
                            <div class="screentime-card__left">
                                <span class="screentime-card__label">Screen Time</span>
                                <span class="screentime-card__value">{{ totalUsedTime }}</span>
                            </div>
                            <button
                                v-if="kidScreenTimeRecommendation"
                                class="screentime-card__info-btn"
                                @click="openScreenTimeRecommendation()"
                                aria-label="Screen time recommendation"
                            >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
                                    <path d="M12 8h.01M11 12h1v4h1" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span>Recommendation</span>
                            </button>
                        </div>
                        <div class="screentime-card__body">
                            <CanvasJSChart
                                v-if="mostUsedApplicationList.length > 0"
                                :options="options"
                                :styles="styleOptions"
                            />
                            <div class="screentime-card__empty" v-else>
                                <img v-if="filterType == 'Day'" :src="dayNoDataGraph" class="img-fluid" />
                                <img v-else :src="weekNoDataGraph" class="img-fluid" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="apps-card">
                    <div class="apps-card__header">
                        <span class="apps-card__title">Most Used Apps</span>
                    </div>

                    <div
                        class="app-row"
                        v-for="application in mostUsedApplicationList"
                        :key="application._id"
                        @click="$router.push({ path: '/application', query: { package_name: application.packageName, profile_id: this.currentProfile._id, serialNumber: this.currentProfile.deviceDetail.serialNumber } })"
                    >
                        <!-- Icon -->
                        <div class="app-row__icon" :style="{ opacity: application.is_app_disabled ? 0.25 : 1 }">
                            <img
                                v-if="application.playStoreDetail"
                                :src="application.playStoreDetail.icon"
                                width="42"
                                height="42"
                                style="border-radius: 12px; display: block;"
                            />
                            <div v-else class="app-row__icon-fallback">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                    <rect x="3" y="3" width="18" height="18" rx="4" stroke="currentColor" stroke-width="1.7"/>
                                    <path d="M9 12h6M12 9v6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
                                </svg>
                            </div>
                        </div>

                        <!-- Info -->
                        <div class="app-row__info">
                            <!-- Name + time on same row -->
                            <div class="app-row__top">
                                <span class="app-row__name">
                                    {{ application.playStoreDetail ? application.playStoreDetail.title : application.packageName }}
                                </span>
                                <span class="app-row__badge" v-if="application.playStoreCategory == 'Others'">Not Managed</span>
                                <span class="app-row__time">
                                    {{ application.timeInMinuteFormatted }}
                                    <span v-if="application.dailyLimit"> / {{ application.dailyLimitFormatted }}</span>
                                </span>
                            </div>

                            <!-- Progress bar -->
                            <div class="app-row__progress-track" v-if="application.dailyLimit">
                                <div
                                    class="app-row__progress-fill"
                                    :class="{ 'app-row__progress-fill--danger': application.timeInMinute >= application.dailyLimit }"
                                    :style="{ width: application.progressBarPercentage + '%' }"
                                ></div>
                            </div>
                            <!-- Thin placeholder line when no limit -->
                            <div class="app-row__progress-track app-row__progress-track--empty" v-else></div>
                        </div>

                        <!-- Chevron -->
                        <div class="app-row__chevron">
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>

                    <!-- Show more / less -->
                    <div class="apps-card__footer" v-if="totalMostUsedApps > 3">
                        <button
                            class="apps-card__footer-btn"
                            v-if="totalMostUsedApps > (this.currentMostUsedAppsPage * this.pageSize)"
                            @click.stop="showMoreMostUsedApps()"
                        >
                            Show more
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                        <button
                            class="apps-card__footer-btn"
                            v-if="(this.currentMostUsedAppsPage * this.pageSize) > 3"
                            @click.stop="showLessMostUsedApps()"
                        >
                            Show less
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                <path d="M18 15l-6-6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>

                    <!-- Empty state -->
                    <div class="apps-card__empty" v-if="mostUsedApplicationList.length == 0">
                        <NoDataIcon />
                        <span>No data to show</span>
                    </div>
                </div>

                <div class="apps-card">
                    <div class="apps-card__header">
                        <span class="apps-card__title">Most Used Categories</span>
                    </div>

                    <div
                        class="app-row"
                        v-for="category in mostUsedCategory"
                        :key="category._id"
                        @click="$router.push({ path: '/category', query: { id: category._id, profileId: this.currentProfile._id, serialNumber: this.currentProfile.deviceDetail.serialNumber } })"
                    >
                        <!-- Icon -->
                        <div class="app-row__icon" :style="{ opacity: category.isCategoryEnabled == false ? 0.25 : 1 }">
                            <img
                                src="https://cdn-icons-png.flaticon.com/512/2603/2603910.png"
                                width="42"
                                height="42"
                                style="border-radius: 12px; display: block;"
                            />
                        </div>

                        <!-- Info -->
                        <div class="app-row__info">
                            <div class="app-row__top">
                                <span class="app-row__name">{{ category.category }}</span>
                                <span class="app-row__time">
                                    {{ category.usedTimeFormat }}
                                    <span v-if="category.dailyLimitTimeFormat"> / {{ category.dailyLimitTimeFormat }}</span>
                                </span>
                            </div>

                            <!-- Progress bar -->
                            <div class="app-row__progress-track" v-if="category.progressBarPercentage">
                                <div
                                    class="app-row__progress-fill"
                                    :class="{ 'app-row__progress-fill--danger': parseInt(category.usedTime) >= parseInt(category.dailyLimitTime) }"
                                    :style="{ width: category.progressBarPercentage + '%' }"
                                ></div>
                            </div>
                            <div class="app-row__progress-track app-row__progress-track--empty" v-else></div>
                        </div>

                        <!-- Chevron -->
                        <div class="app-row__chevron">
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>

                    <!-- Show more / less -->
                    <div class="apps-card__footer" v-if="totalMostUsedCategory > 3">
                        <button
                            class="apps-card__footer-btn"
                            v-if="totalMostUsedCategory > (this.currentCategoryPage * this.pageSize)"
                            @click.stop="showMoreCategory()"
                        >
                            Show more
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                        <button
                            class="apps-card__footer-btn"
                            v-if="(this.currentCategoryPage * this.pageSize) > 3"
                            @click.stop="showLessCategory()"
                        >
                            Show less
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                <path d="M18 15l-6-6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>

                    <!-- Empty state -->
                    <div class="apps-card__empty" v-if="mostUsedCategory.length == 0">
                        <NoDataIcon />
                        <span>No data to show</span>
                    </div>
                </div>

                <div class="last-updated">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" style="flex-shrink:0">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"/>
                        <path d="M12 6v6l4 2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                    </svg>
                    Last updated: {{ lastUpdated }}
                </div>
            </div>
        </div>
        <div class="container" :style="{ 'background': '#f7f7f7', 'max-width': '575px' }">
            <div class="container-dark">
                    
                    
                    <!--<div class="profile-section" :style="{ 'border': 'unset' }">
                        <h5 class="pb-2"><b>Activity</b></h5>
                        <div class="btn-group btn-group-justified nav nav-pills justify-content-center" role="tablist" >
                            <a class="btn btn-light nav-link w-50 active" :style="{ 'text-decoration': 'none', 'padding': '4px' }" href="javascript:void(0)" role="tab" data-toggle="tab" @click="changeFilterType('Day')">Day</a>
                            <a class="btn btn-light nav-link w-50" :style="{ 'text-decoration': 'none', 'padding': '4px' }" href="javascript:void(0)" role="tab" data-toggle="tab" @click="changeFilterType('Week')">Week</a>
                        </div>
                        <div class="pt-3">
                            <div class="input-group" :style="{ 'padding-right': '2px', 'background': 'white'}" :data-filter-type="filterType">
                                <div class="input-group-prepend"> 
                                    <div class="input-group-text" :style="{ 'background-color': 'white', 'border': 'unset' }" id="btnGroupAddon">
                                        <a class="text-black" href="javascript:void(0)" @click="previousDate()">
                                            <ArrowLeftIcon />  
                                        </a>
                                    </div>
                                </div>
                                <div class="form-control text-center text-black" :style="{ 'border': 'unset', 'font-weight': 'bold' }">{{ this.formattedDate }}</div>
                                <div class="input-group-prepend">
                                    <div class="input-group-text" :style="{ 'background-color': 'white', 'border': 'unset' }" id="btnGroupAddon">
                                        <a class="text-black" href="javascript:void(0)" @click="nextDate()">
                                            <ArrowRightIcon />
                                        </a>
                                    </div>
                                </div>
                                <div class="input-group-append">
                                    <div class="input-group-text date-picker-wrapper" :style="{ 'background-color': 'white', 'border': 'unset' }">
                                        <label for="datePickerInput" class="date-picker-label">
                                            <i class="fas fa-calendar-alt calendar-icon"></i>
                                        </label>
                                        <input
                                            id="datePickerInput"
                                            ref="datePicker"
                                            type="date"
                                            v-model="selectedDate"
                                            @change="onDateChange"
                                            class="date-picker-input"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="profile-section" style="border-bottom: unset;">
                        <div class="card" :style="{ 'border': 'unset', 'max-width': 'unset' }">
                            <div class="card-body">
                                <h6 class="text-black">
                                    <b>Screen Time: </b><span class="text-primary"><b>{{ totalUsedTime }}</b> </span>
                                </h6> 
                                <small class="text-muted" v-if="kidScreenTimeRecommendation">
                                    <b>Daily active Screen Time Recommendation</b> 
                                    <a href="javascript:void(0)" @click="openScreenTimeRecommendation()" class="text-black">&nbsp;<i class="fas fa-info-circle fa-lg"></i></a>
                                    <br><br>
                                </small>
                                <CanvasJSChart v-if="mostUsedApplicationList.length > 0" :options="options" :styles="styleOptions"/>
                                <div v-else>
                                    <img v-if="filterType == 'Day'" :src="dayNoDataGraph" class="img-fluid" />
                                    <img v-else :src="weekNoDataGraph" class="img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="profile-section" style="border-bottom: unset;">
                        <div class="card" :style="{ 'border': 'unset', 'max-width': 'unset'}">
                            <div class="card-body">
                                <h6 class="text-black"><b>Most Used Apps</b></h6>
                                
                                <div class="row border-bottom p-2" v-for="application in mostUsedApplicationList" :key="application._id">
                                    <div class="col-xs-2" v-if="application.playStoreDetail" :style="{ opacity: application.is_app_disabled ? 0.2 : 1 }">
                                        <img :src="application.playStoreDetail.icon" style="height: 40px; width: 40px;border-radius: 10px;">
                                    </div>&nbsp;
                                    <div class="col-xs-10" :style="{ 'width': '48%' }">
                                        <a href="javascript:void(0)" :style="{ 'font-size': '14px' }" @click="$router.push({ path: '/application', query: { package_name: application.packageName, profile_id: this.currentProfile._id, serialNumber: this.currentProfile.deviceDetail.serialNumber} })" class="text-black">
                                            <span v-if="application.playStoreDetail">
                                                {{ application.playStoreDetail.title }} 
                                                <label v-if="!application.dailyLimit"> - <b>{{ application.timeInMinuteFormatted }}</b></label>
                                            </span>
                                            <span v-else>{{ application.packageName }}
                                                <label v-if="!application.dailyLimit"> - <b>{{ application.timeInMinuteFormatted }}</b></label>
                                            </span>
                                            &nbsp;<span class="badge badge-danger" v-if="application.playStoreCategory == 'Others'">
                                                Not Managed
                                            </span>
                                        </a>
                                        <div>
                                            <div class="progress" v-if="application.dailyLimit">
                                                <div class="progress-bar" :class="{'bg-danger': application.timeInMinute >= application.dailyLimit }" role="progressbar" :style="{ width: application.progressBarPercentage + '%' }" aria-valuemax="100">
                                                    <span v-if="application.dailyLimit"><b>{{ application.timeInMinuteFormatted }}</b> / {{ application.dailyLimitFormatted }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xs-2" :style="{ 'width': '36%', 'text-align': 'right', 'padding-top': '5px' }">
                                        <a href="javascript:void(0)" :style="{ 'font-size': '14px' }" @click="$router.push({ path: '/application', query: { package_name: application.packageName, profile_id: this.currentProfile._id, serialNumber: this.currentProfile.deviceDetail.serialNumber} })" class="text-black">
                                            <ArrowLeftPlainIcon />
                                        </a>
                                    </div>
                                </div>
                                <div class="row p-2" v-if="totalMostUsedApps > 3">
                                    <div class="col-xs-3"></div>
                                    <div class="col-xs-5 pl-3" v-if="totalMostUsedApps > (this.currentMostUsedAppsPage * this.pageSize)">
                                        <a href="javascript:void(0)" @click="showMoreMostUsedApps()">
                                            <b>Show More</b>
                                        </a>
                                    </div>
                                    <div class="col-xs-5 pl-3" v-if="(this.currentMostUsedAppsPage * this.pageSize) > 3">
                                        <a href="javascript:void(0)" @click="showLessMostUsedApps()">
                                            <b>Show Less</b>
                                        </a>
                                    </div>
                                </div>
                                <p v-if="mostUsedApplicationList.length == 0">
                                    <NoDataIcon />
                                    No data to show
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="profile-section" style="border-bottom: unset;">
                        <div class="card" :style="{ 'border': 'unset', 'max-width': 'unset' }">
                            <div class="card-body">
                                <h6 class="text-black"><b>Most Used Categories</b></h6>
                                <div class="row border-bottom p-2" v-for="category in mostUsedCategory" :key="category._id" >
                                    <div class="col-xs-2" :style="{ opacity: category.isCategoryEnabled == false ? 0.2 : 1 }">
                                        <img src="https://cdn-icons-png.flaticon.com/512/2603/2603910.png" style="height: 40px; width: 40px;border-radius: 10px;">
                                    </div>&nbsp;
                                    <div class="col-xs-12" :style="{ 'width': '50%' }">
                                        <span>
                                            <a href="javascript:void(0)" @click="$router.push({ path: '/category', query: { id: category._id, profileId: this.currentProfile._id, serialNumber: this.currentProfile.deviceDetail.serialNumber }})" class="text-black">
                                                {{ category.category }} <small v-if="!category.progressBarPercentage"> - <b>{{ category.usedTimeFormat }}</b> / {{ category.dailyLimitTimeFormat }}</small>
                                            </a>
                                            <div v-if="category.progressBarPercentage">
                                                <div class="progress">
                                                    <div class="progress-bar" role="progressbar" :class="{'bg-danger': parseInt(category.usedTime) >= parseInt(category.dailyLimitTime) }"  :style="{ 'width': category.progressBarPercentage+'%'}" aria-valuemax="100">
                                                        <span><b>{{ category.usedTimeFormat }}</b> / {{ category.dailyLimitTimeFormat }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="col-xs-2" :style="{ 'width': '34%', 'text-align': 'right', 'padding-top': '5px' }">
                                        <a href="javascript:void(0)" @click="$router.push({ path: '/category', query: { id: category._id, profileId: this.currentProfile._id, serialNumber: this.currentProfile.deviceDetail.serialNumber }})" class="text-black">
                                            <ArrowLeftPlainIcon />
                                        </a>
                                    </div>
                                </div>
                                <div class="row p-2" v-if="totalMostUsedCategory > 3">
                                    <div class="col-xs-3"></div>
                                    <div class="col-xs-5 pl-3" v-if="totalMostUsedCategory > (this.currentCategoryPage * this.pageSize)">
                                        <a href="javascript:void(0)" @click="showMoreCategory()">
                                            <b>Show More</b>
                                        </a>
                                    </div>
                                    <div class="col-xs-5 pl-3" v-if="(this.currentCategoryPage * this.pageSize) > 3">
                                        <a href="javascript:void(0)" @click="showLessCategory()">
                                            <b>Show Less</b>
                                        </a>
                                    </div>
                                </div>
                                <p v-if="mostUsedCategory.length == 0">
                                    <NoDataIcon />
                                    No data to show
                                </p>
                            </div>
                        </div>
                    </div>-->
                    
                    <!--<div class="profile-section text-center pt-2">
                        Last Update: {{ lastUpdated }}
                    </div>-->
                <KidFooter v-if="currentProfile" :profileId="currentProfile._id" :serialNumber="currentProfile.deviceDetail.serialNumber" />
            </div>
        </div>
    </div>
</template>
<script>
import KidsService from "../../services/KidsService";
import ProfileService from "../../services/ProfileService";
import DeviceService from "../../services/DeviceService";
import UserService from "../../services/UserService";

import KidHeader from '@/components/KidHeader.vue'
import KidFooter from '@/components/KidFooter.vue'
import DownArrowIcon from '@/components/icons/DownArrowIcon.vue'
import WifiIcon from '@/components/icons/WifiIcon.vue'
import NoWifiIcon from '@/components/icons/NoWifiIcon.vue'
import FullBatteryIcon from '@/components/icons/FullBatteryIcon.vue'
import HalfBatteryIcon from '@/components/icons/HalfBatteryIcon.vue'
import LowBatteryIcon from '@/components/icons/LowBatteryIcon.vue'
import ArrowLeftIcon from '@/components/icons/ArrowLeftIcon.vue'
import ArrowRightIcon from '@/components/icons/ArrowRightIcon.vue'
import ArrowLeftPlainIcon from '@/components/icons/ArrowLeftPlainIcon.vue'
import NoDataIcon from '@/components/icons/NoDataIcon.vue'
import ThreeLineMenuIcon from '@/components/icons/ThreeLineMenuIcon.vue'
import NotificationBellIcon from '@/components/icons/NotificationBellIcon.vue'
import DefaultProfilePicIcon from '@/components/icons/DefaultProfilePicIcon.vue'

//let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

export default {
  name: 'Device Detail',
  components: {
    KidHeader,
    KidFooter,
    DownArrowIcon,
    NoWifiIcon,
    WifiIcon,
    FullBatteryIcon,
    HalfBatteryIcon,
    LowBatteryIcon,
    ArrowLeftIcon,
    ArrowRightIcon,
    ArrowLeftPlainIcon,
    NoDataIcon,
    ThreeLineMenuIcon,
    NotificationBellIcon,
    DefaultProfilePicIcon
  },
  props: {
    topLeftImage: {
        type: String,
        default: "./images/home-top-left.png",
    },
    appListIcon: {
        type: String,
        default: "./images/app-list-icon.png",
    },
    dayNoDataGraph: {
        type: String,
        default: "./images/day-nodata-graph.png",
    },
    weekNoDataGraph: {
        type: String,
        default: "./images/week-nodata-graph.png",
    },
    enrollmentQrCode: {
        type: String,
        default: "./images/kids-default-enrollment-qr-code.png",
    },
    logo: {
        type: String,
        default: "./images/lya-logo.png",
    },
    mediaVouchers: {
        type: String,
        default: "./images/mediengutscheine_diverses-printmedium_klicksafe.pdf",
    },
  },
  data() {
    return {
        dismissedAlerts: {
            deviceLimit: false,
            defaultPassword: false,
            fullAccess: false,
        },
        profileId: this.$route.query.profileId,
        isDisabled: false,
        currentProfile: null,
        profileList: [],
        installedApplicationList: [],
        
        allMostUsedApplicationList: [],
        mostUsedApplicationList: [],
        totalMostUsedApps: 0,
        currentMostUsedAppsPage: 1,

        allMostUsedCategory: [],
        mostUsedCategory: [],
        totalMostUsedCategory: 0,
        currentCategoryPage: 1,
        pageSize: 3,
        defaultPageSize: 3,

        currentDate: new Date(),
        formattedDate: new Date().toLocaleDateString("en-US", this.$dateOptions),
        lastUpdated: "No data found.",
        options: null,
        styleOptions: {
          width: "100%",
          height: "250px"
        },
        iframeMapUrl: "",
        fullMapRedirectUrl: "",
        filterType: "Day",
        weekType: "Current",
        kidAge: null,
        kidScreenTimeRecommendation: "",
        totalUsedTime:"",
        sleepMode: false,
        showNoDeviceSection: false,
        useDefaultPassword: this.$route.query.useDefaultPassword,
        kidsAppProtectionStatus: false,

        kidName: null,
        birthMonth: null,
        birthYear: null,
        existingProfilePic: null,
        newProfilePic: null,
        kidProfileImagePayload: null,
        previewImage: null,
        months: [
            { name: 'January', value: 1 },
            { name: 'February', value: 2 },
            { name: 'March', value: 3 },
            { name: 'April', value: 4 },
            { name: 'May', value: 5 },
            { name: 'June', value: 6 },
            { name: 'July', value: 7 },
            { name: 'August', value: 8 },
            { name: 'September', value: 9 },
            { name: 'October', value: 10 },
            { name: 'November', value: 11 },
            { name: 'December', value: 12 }
        ],

        showMap: false,
        hideGoogleLogin: false,
        showNoInternet: false,
        subscriptionWarnings: [],
        renewingSubscriptionId: null, // tracks which subscription is currently processing
        selectedDate: '', // Add this line
        socket: null,

        fetchingLocation: false,
        locationHistoryLoading: false,
        locationHistory: [],
        showLocationHistory: false,
    }
  },
  computed: {
    
  },
  methods: {
    onDateChange() {
        if (this.selectedDate) {
            // Parse the selected date
            const parts = this.selectedDate.split('-');
            const year = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1; // JavaScript months are 0-indexed
            const day = parseInt(parts[2]);
            
            // Update currentDate
            this.currentDate = new Date(year, month, day);
            
            // Update formatted date display
            this.formattedDate = this.currentDate.toLocaleDateString("en-US", this.$dateOptions);
            
            // Refresh data
            this.getCategoryStackedChart();
            this.getDeviceProfileMostUsedApplicationList();
            this.getMostUsedCategory();
        }
    },
    handleFileUpload(event) {
        const file = event.target.files[0];
        this.kidProfileImagePayload = file;
        if (file) {
            this.newProfilePic = URL.createObjectURL(file);
        }
    },
    toggleDataSeries(e) {
        if (typeof (e.dataSeries.visible) === "undefined" || e.dataSeries.visible) {
          e.dataSeries.visible = false;
        }
        else {
          e.dataSeries.visible = true;
        }
        e.chart.render();
    },
    calculateBoundingBox(latStr, longStr, zoomOutFactor) {
        const latitude = parseFloat(latStr);
        const longitude = parseFloat(longStr);

        // Check if the conversion was successful (NaN check)
        if (isNaN(latitude) || isNaN(longitude)) {
            console.error("Invalid latitude or longitude string");
            return null;
        }

        // Calculate the bounding box by subtracting/adding the zoomOutFactor to the center point coordinates
        const west = longitude - zoomOutFactor;
        const east = longitude + zoomOutFactor;
        const south = latitude - zoomOutFactor;
        const north = latitude + zoomOutFactor;
        
        // Return the bounding box as an object
        return {
            west: west,
            south: south,
            east: east,
            north: north
        };
    },
    async getKidsList() {
      let data = {
        profileId: (this.profileId) ? "" : this.profileId,
        search_profile_name: this.profileName,
        search_profile_type: "Android",
        pageSize: 50,
      }
      await KidsService.getKidsList(data)
        .then((response) => {
            this.profileList = response.data.data;
            if (this.profileList.length > 0 && this.profileList[0].deviceDetail) {

                this.showNoDeviceSection = false;
                if (this.profileId) {
                    const selectedProfile = this.profileList.find(item => item._id == this.profileId);
                    this.currentProfile = selectedProfile;
                } else {
                    this.currentProfile = this.profileList[0];
                    this.profileId = this.profileList[0]._id;
                }
                this.kidName = this.currentProfile.profile_name;
                if (this.currentProfile.deviceDetail) {
                    this.birthMonth = this.currentProfile.deviceDetail.birthMonth;
                    this.birthYear = this.currentProfile.deviceDetail.birthYear;
                    this.existingProfilePic = (this.currentProfile.deviceDetail.kidProfilePic) ? this.currentProfile.deviceDetail.kidProfilePic : null;
                    this.showMap = this.currentProfile.deviceDetail.enableLocationMapDisplay
                }

                this.kidsAppProtectionStatus = this.currentProfile.deviceDetail.protectionEnabled;
                //this.currentProfile = this.profileList[0];
                this.kidAge = this.currentProfile.deviceDetail.kidAge;
                this.sleepMode = this.currentProfile.sleepMode;
                if (this.kidAge >= 0 && this.kidAge < 2) {
                    this.kidScreenTimeRecommendation = "0 to 2 Years: In babies and toddlers, it is recommended to avoid screen media as much as possible."
                } else if (this.kidAge && this.kidAge >= 2 && this.kidAge < 4) {
                    this.kidScreenTimeRecommendation = "2 to 4 Years: For preschool children, the recommended time ranges from 5 to 10 minutes a day to a maximum of one hour of screen time. The latter should be the exception and not occur every day."
                } else if (this.kidAge && this.kidAge >= 4 && this.kidAge <= 8) {
                    this.kidScreenTimeRecommendation = "4 to 8 Years: Kindergarten children and primary school students should not sit in front of the screen for longer than 30 to a maximum of 60 minutes per day."
                } else if (this.kidAge && this.kidAge >= 9 && this.kidAge < 10) {
                    this.kidScreenTimeRecommendation = "9 to 10 Years: Kindergarten children and primary school students should not sit in front of the screen for longer than 30 to a maximum of 60 minutes per day."
                } else if (this.kidAge && this.kidAge >= 10) {
                    this.kidScreenTimeRecommendation = "From 10 years: With older children, a weekly time budget can be agreed upon. For example, one hour per year of age per week in the form of media vouchers.  Here you find a template: <a target='_blank' href='"+this.mediaVouchers+"'>Template</a>"
                } else {
                    this.kidScreenTimeRecommendation = ""
                }
                this.setupSocket(); // ← must be here, after currentProfile is set
                this.getRecentLocations(); // ← add this
                this.getSubscriptionStatus();
                this.getDeviceProfileMostUsedApplicationList();
                this.getDeviceProfileApplicationList();
                this.getMostUsedCategory();
                this.getCategoryStackedChart();
                if (this.currentProfile.deviceDetail.lastDeviceLocation) {
                    let lat = parseFloat(this.currentProfile.deviceDetail.lastDeviceLocation.latitude);
                    let long = parseFloat(this.currentProfile.deviceDetail.lastDeviceLocation.longitude);

                    const centerLat = lat;   // Latitude of your center
                    const centerLong = long;  // Longitude of your center
                    const zoomOutFactor = 0.001;  // The factor to zoom out by (in degrees)

                    const boundingBox = this.calculateBoundingBox(centerLat, centerLong, zoomOutFactor);
                    const bbox = `${boundingBox.west},${boundingBox.south},${boundingBox.east},${boundingBox.north}`;
                    this.iframeMapUrl = `/map.html?lat=${lat}&long=${long}&zoom=12&bbox=${bbox}`;
                    //this.iframeMapUrl = "https://www.openstreetmap.org/export/embed.html?bbox=" + boundingBox.west + "," + boundingBox.south + "," + boundingBox.east + "," + boundingBox.north + "&zoom=12&layer=mapnik&marker=" + lat + "," + long;
                    this.fullMapRedirectUrl = "https://www.openstreetmap.org/?lat="+lat+"&lon="+long+"&zoom=13&layers=Q&mlat="+lat+"&mlon="+long;
                }
                if (this.currentProfile.deviceDetail.lastDeviceActivationDate) {
                    this.lastUpdated = new Date(this.currentProfile.deviceDetail.lastDeviceActivationDate).toLocaleDateString("en-US", this.$dateOptions) + " " + new Date(this.currentProfile.deviceDetail.lastDeviceActivationDate).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
                } else {
                    this.lastUpdated = "No data found.";
                }
            } else {
                this.$router.push({ path: '/parent-profile'})
                this.showNoDeviceSection = true;
            }
        }).catch((e) => {
            // ✅ NETWORK ERROR (No internet)
            if (!e.response) {
                this.$toast.error("No internet connection");
                this.showNoInternet = true; // create this flag
                return;
            }

            // ✅ API responded but says logout
            if (e.response.data.is_logout === true) {
                this.$router.push({ path: '/login' });
            } else {
                this.$toast.error(e.response.data.respones_msg);
            }
        });
    },
    setupSocket() {
        const serialNumber = this.currentProfile?.deviceDetail?.serialNumber;

        console.log("[SOCKET] setupSocket called | serialNumber:", serialNumber);

        if (!serialNumber) {
            console.warn("[SOCKET] No serialNumber found, skipping socket setup");
            return;
        }

        // ── Disconnect existing socket before creating new one ──
        if (this.socket) {
            console.log("[SOCKET] Disconnecting existing socket");
            this.socket.disconnect();
            this.socket = null;
        }

        this.socket = io(process.env.VUE_APP_API_BASE_URL, {
            auth: {
                serialNumber,
                token: localStorage.getItem('token')
            }
        });

        this.socket.on("connect", () => {
            this.socket.emit('join_device_room', { serialNumber });
            console.log("[SOCKET] Joined room | room:", `device_room_${serialNumber}`);
            console.log("[SOCKET] Connected | serialNumber:", serialNumber, "| socketId:", this.socket.id);
        });

        this.socket.on("connect_error", (err) => {
            console.error("[SOCKET] Connect Error:", err.message);
        });

        const eventName = `parent_update_${serialNumber}`;

        this.socket.off(eventName);
        this.socket.on(eventName, (data) => {
            console.log("[SOCKET] Parent Update received:", data);

            if (!this.currentProfile?.deviceDetail) return;

            // ── Update wifiConnected reactively ──
            this.currentProfile.deviceDetail.wifiConnected = data.wifiConnected;
            if (data.batteryPercentage) {
                this.currentProfile.deviceDetail.batteryPercentage = data.batteryPercentage;
            }
            if (data.lastDeviceLocation) {
                this.currentProfile.deviceDetail.lastDeviceLocation = data.lastDeviceLocation;
                if (this.currentProfile.deviceDetail.lastDeviceLocation) {
                    let lat = parseFloat(this.currentProfile.deviceDetail.lastDeviceLocation.latitude);
                    let long = parseFloat(this.currentProfile.deviceDetail.lastDeviceLocation.longitude);

                    const centerLat = lat;   // Latitude of your center
                    const centerLong = long;  // Longitude of your center
                    const zoomOutFactor = 0.001;  // The factor to zoom out by (in degrees)

                    const boundingBox = this.calculateBoundingBox(centerLat, centerLong, zoomOutFactor);
                    const bbox = `${boundingBox.west},${boundingBox.south},${boundingBox.east},${boundingBox.north}`;
                    this.iframeMapUrl = `/map.html?lat=${lat}&long=${long}&zoom=12&bbox=${bbox}`;
                    //this.iframeMapUrl = "https://www.openstreetmap.org/export/embed.html?bbox=" + boundingBox.west + "," + boundingBox.south + "," + boundingBox.east + "," + boundingBox.north + "&zoom=12&layer=mapnik&marker=" + lat + "," + long;
                    this.fullMapRedirectUrl = "https://www.openstreetmap.org/?lat="+lat+"&lon="+long+"&zoom=13&layers=Q&mlat="+lat+"&mlon="+long;
                }
            }
            console.log("[SOCKET] wifiConnected updated to:", data.wifiConnected);
        });

        this.socket.on("disconnect", () => {
            console.log("[SOCKET] Disconnected | serialNumber:", serialNumber);
        });
    },
    openKidsListModal() {
        $('.collapse').collapse('hide');
        $('#navbarToggleExternalContent').collapse('show');
    },
    closeKidsScreen() {
        $('#navbarToggleExternalContent').collapse('hide');
    },
    getDeviceProfileApplicationList() {
      let data = {
        profile_id: this.currentProfile._id,
        install_type: "FORCE_INSTALLED",
        //serialNumber: this.currentProfile.deviceDetail.serialNumber,
      }
      ProfileService.getDeviceProfileApplicationList(data)
        .then((response) => {
          this.installedApplicationList = response.data.data;
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async getDeviceProfileMostUsedApplicationList() {
      let data = {
        profileId: this.currentProfile._id,
        serialNumber: this.currentProfile.deviceDetail.serialNumber,
        currentDate: this.currentDate,
        filterType: this.filterType,
        weekType: this.weekType
      }
      await KidsService.getDeviceProfileMostUsedApplicationList(data)
        .then((response) => {
            let mostUsedApplicationList = response.data.data;
            this.allMostUsedApplicationList = mostUsedApplicationList;
            this.totalMostUsedApps = mostUsedApplicationList.length
            this.totalUsedTime = response.data.totalUsedTime
            this.mostUsedApplicationList = mostUsedApplicationList.slice(0, this.pageSize);
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    showMoreMostUsedApps() {
        this.currentMostUsedAppsPage = this.currentMostUsedAppsPage + 1;
        let pageSize = this.pageSize * this.currentMostUsedAppsPage;
        this.mostUsedApplicationList = this.allMostUsedApplicationList.slice(0, pageSize);
    },
    showLessMostUsedApps() {
        this.mostUsedApplicationList = this.mostUsedApplicationList.slice(0, 3);
        this.currentMostUsedAppsPage = 1;
    },
    switchProfile(profile) {
        this.profileId = profile._id;
        this.$router.replace({
            path: this.$route.path, // Keeps the current path
            query: { 
                ...this.$route.query, // Retain existing query parameters
                profileId: profile._id 
            }
        });
        this.iframeMapUrl = "";
        this.fullMapRedirectUrl = "";
        this.currentProfile = profile;
        this.setupSocket(); // ← must be here, after currentProfile is set
        this.getRecentLocations(); // ← add this
        this.getDeviceProfileMostUsedApplicationList();
        this.getDeviceProfileApplicationList();
        this.getMostUsedCategory();
        this.getCategoryStackedChart();

        this.kidName = this.currentProfile.profile_name;
        if (this.currentProfile.deviceDetail) {
            this.birthMonth = this.currentProfile.deviceDetail.birthMonth;
            this.birthYear = this.currentProfile.deviceDetail.birthYear;
            this.existingProfilePic = this.currentProfile.deviceDetail.kidProfilePic;
            this.showMap = this.currentProfile.deviceDetail.enableLocationMapDisplay
        }
        this.kidAge = this.currentProfile.deviceDetail.kidAge;
        this.sleepMode = this.currentProfile.sleepMode;
        if (this.kidAge >= 0 && this.kidAge < 2) {
            this.kidScreenTimeRecommendation = "0 to 2 Years: In babies and toddlers, it is recommended to avoid screen media as much as possible."
        } else if (this.kidAge && this.kidAge >= 2 && this.kidAge < 4) {
            this.kidScreenTimeRecommendation = "2 to 4 Years: For preschool children, the recommended time ranges from 5 to 10 minutes a day to a maximum of one hour of screen time. The latter should be the exception and not occur every day."
        } else if (this.kidAge && this.kidAge >= 4 && this.kidAge <= 8) {
            this.kidScreenTimeRecommendation = "4 to 8 Years: Kindergarten children and primary school students should not sit in front of the screen for longer than 30 to a maximum of 60 minutes per day."
        } else if (this.kidAge && this.kidAge >= 9 && this.kidAge < 10) {
            this.kidScreenTimeRecommendation = "9 to 10 Years: Kindergarten children and primary school students should not sit in front of the screen for longer than 30 to a maximum of 60 minutes per day."
        } else if (this.kidAge && this.kidAge >= 10) {
            this.kidScreenTimeRecommendation = "From 10 years: With older children, a weekly time budget can be agreed upon. For example, one hour per year of age per week in the form of media vouchers.  Here you find a template: <a target='_blank' href='https://www.klicksafe.de/fileadmin/cms/download/Material/Div._Printmedium/Mediengutscheine_klicksafe_Deutsch_2021.pdf'>Template</a>"
        } else {
            this.kidScreenTimeRecommendation = ""
        }
        if (this.currentProfile.deviceDetail.lastDeviceLocation) {
            let lat = this.currentProfile.deviceDetail.lastDeviceLocation.latitude;
            let long = this.currentProfile.deviceDetail.lastDeviceLocation.longitude;

            const centerLat = lat;   // Latitude of your center
            const centerLong = long;  // Longitude of your center
            const zoomOutFactor = 0.001;  // The factor to zoom out by (in degrees)

            const boundingBox = this.calculateBoundingBox(centerLat, centerLong, zoomOutFactor);
            const bbox = `${boundingBox.west},${boundingBox.south},${boundingBox.east},${boundingBox.north}`;
            this.iframeMapUrl = `/map.html?lat=${lat}&long=${long}&zoom=12&bbox=${bbox}`;
            //this.iframeMapUrl = "https://www.openstreetmap.org/export/embed.html?bbox="+boundingBox.west+","+boundingBox.south+","+boundingBox.east+","+boundingBox.north+"&layer=mapquest&marker="+lat+","+long+"&zoom=12"
            this.fullMapRedirectUrl = "https://www.openstreetmap.org/?lat="+lat+"&lon="+long+"&zoom=13&layers=Q&mlat="+lat+"&mlon="+long;
        }
        if (this.currentProfile.deviceDetail.lastDeviceActivationDate) {
            this.lastUpdated = new Date(this.currentProfile.deviceDetail.lastDeviceActivationDate).toLocaleDateString("en-US", this.$dateOptions) + " " + new Date(this.currentProfile.deviceDetail.lastDeviceActivationDate).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
        } else {
            this.lastUpdated = "No data found.";
        }
        this.kidsAppProtectionStatus = this.currentProfile.deviceDetail.protectionEnabled;
        $('#navbarToggleExternalContent').collapse('hide');
    },
    async getMostUsedCategory() {
      let data = {
        profileId: this.currentProfile._id,
        serialNumber: this.currentProfile.deviceDetail.serialNumber,
        currentDate: this.currentDate,
        filterType: this.filterType,
        weekType: this.weekType
      }
      await KidsService.getMostUsedCategory(data)
        .then((response) => {
            let mostUsedCategory = response.data.data
            this.allMostUsedCategory = mostUsedCategory;
            this.totalMostUsedCategory = mostUsedCategory.length
            this.mostUsedCategory = mostUsedCategory.slice(0, this.pageSize);
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    showMoreCategory() {
        this.currentCategoryPage = this.currentCategoryPage + 1;
        let pageSize = this.pageSize * this.currentCategoryPage;
        this.mostUsedCategory = this.allMostUsedCategory.slice(0, pageSize);
    },
    showLessCategory() {
        this.mostUsedCategory = this.allMostUsedCategory.slice(0, 3);
        this.currentCategoryPage = 1;
    },
    async getCategoryStackedChart() {
        let data = {
        profileId: this.currentProfile._id,
        serialNumber: this.currentProfile.deviceDetail.serialNumber,
        currentDate: this.currentDate,
        filterType: this.filterType,
        weekType: this.weekType
      }
      await KidsService.getCategoryStackedChart(data)
        .then((response) => {
            this.options = response.data.data
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async updateKidProfileDetail() {
        this.isDisabled =true;
        let formData = new FormData();
        formData.append("image", this.kidProfileImagePayload);
        formData.append("kidName", this.kidName); 
        formData.append("birthMonth", this.birthMonth)
        formData.append("birthYear", this.birthYear);
        formData.append("profileId", this.currentProfile._id);
        formData.append("serialNumber", this.currentProfile.deviceDetail.serialNumber);
        KidsService.updateKidProfileDetail(formData)
        .then((response) => {
            this.getKidsList();
            this.newProfilePic = null;
            this.kidProfileImagePayload = null;
            this.isDisabled =false;
            this.$toast.success(response.data.respones_msg);
            $('.collapse').collapse('hide');
        }).catch((e) => {
            this.isDisabled =false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    formatDateForInput(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    },
    changeFilterType(type) {
        this.filterType = type;
        if (this.filterType == "Day") {
            this.formattedDate = this.currentDate.toLocaleDateString("en-US", this.$dateOptions);
            this.selectedDate = this.formatDateForInput(this.currentDate);
        } else {
            this.formattedDate = "This Week";
            this.weekType = "Current";
            this.selectedDate = ''; // Clear date picker in Week mode
        }
    },
    previousDate() {
        if (this.filterType == "Day") {
            let day = this.currentDate.getTime() - (1 * 24 * 60 * 60 * 1000);
            this.currentDate.setTime(day);
            this.formattedDate = this.currentDate.toLocaleDateString("en-US", this.$dateOptions);
            this.selectedDate = this.formatDateForInput(this.currentDate);
        } else {
            this.formattedDate = "Previous Week"
            this.weekType = "Previous";
        }
        this.getCategoryStackedChart();
        this.getDeviceProfileMostUsedApplicationList();
        this.getMostUsedCategory();
    },
    nextDate() {
        if (this.filterType == "Day") {
            let day = this.currentDate.getTime() + (1 * 24 * 60 * 60 * 1000);
            this.currentDate.setTime(day);
            this.formattedDate = this.currentDate.toLocaleDateString("en-US", this.$dateOptions)
            this.selectedDate = this.formatDateForInput(this.currentDate);
        } else {
            this.formattedDate = "This Week",
            this.weekType = "Current";
        }
        
        this.getCategoryStackedChart();
        this.getDeviceProfileMostUsedApplicationList();
        this.getMostUsedCategory();
    },
    openScreenTimeRecommendation() {
        $('.collapse').collapse('hide');
        $('#ScreenTimeRecommendationPopup').collapse('show')
    }, 
    closeScreenTimeRecommendation(){
        $('#ScreenTimeRecommendationPopup').collapse('hide')
    },
    openSleepModeModal() {
        $('.collapse').collapse('hide');
        $('#sleepModePopup').collapse('show')
    },
    closeSleepMode(){
        $('#sleepModePopup').collapse('hide')
    },
    closeProfilePage() {
        $('#kidsProfilePage').collapse('hide')
    },
    openKidsprofilePageModal() {
        $('.collapse').collapse('hide');
        $('#kidsProfilePage').collapse('show')
    },
    openKidsAppStatusPopup() {
        $('.collapse').collapse('hide');
        $('#kidsAppProtectionPopup').collapse('hide')
        $('#kidsAppStatusPopup').collapse('show')
    },
    closeKidsAppStatusPopup(){
        $('#kidsAppStatusPopup').collapse('hide')
    },
    openKidsAppProtactionPopup() {
        $('.collapse').collapse('hide');
        $('#kidsAppStatusPopup').collapse('hide')
        $('#kidsAppProtectionPopup').collapse('show')
    },
    closeKidsAppProtactionPopup(){
        $('#kidsAppProtectionPopup').collapse('hide')
    },
    async toggleSleepMode() {
        let data = {
            profileId: this.currentProfile._id,
            sleepMode: (this.sleepMode == true) ? false : true,
            serialNumber: this.currentProfile.deviceDetail.serialNumber
        }
        await KidsService.toggleSleepMode(data)
        .then((response) => {
            this.$toast.success(response.data.respones_msg);  
            $('#sleepModePopup').collapse('hide')
            //this.sleepMode = (this.sleepMode == true) ? false : true
            if (this.currentProfile.deviceDetail.type == "Ios") {
                this.iosApplyPolicy();
            } else {
                this.applyPolicy();
            }
            setTimeout(() => {
                    this.getKidsList();
            }, 2000);

        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    iosApplyPolicy() {
          this.isDisabled = true;
          let data = {
            profile_id: this.currentProfile._id,
          }
          ProfileService.iosApplyPolicy(data)
          .then((response) => {
            this.$toast.success(response.data.respones_msg);
            this.isDisabled = false;
          }).catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
            this.isDisabled = false;
            /*if (e.response.data.data.payment_redirection) {
              this.$router.push({ path: 'plan-list'})
            }*/
          });
    },
    applyPolicy() {
      this.isDisabled = true;
      let data = {
        profile_id: this.currentProfile._id,
        serialNumber: this.currentProfile.deviceDetail.serialNumber
      };

      ProfileService.applyPolicy(data)
        .then((response) => {
          this.isDisabled = false;
          this.$toast.success(response.data.respones_msg);
        })
        .catch((e) => {
          this.isDisabled = false;
          //this.$toast.error(e.response.data.respones_msg);
        });
    },
    doLogout() {
        UserService.logout()
        .then((response) => {
            localStorage.setItem('token', "");
            this.$toast.success(response.data.respones_msg);
            this.$router.push('login');
        }).catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async updateAppProtectionStatus() {
        let data = {
            profileId: this.currentProfile._id,
            kidsAppProtectionStatus: this.kidsAppProtectionStatus,
            serialNumber: this.currentProfile.deviceDetail.serialNumber
        }
        await KidsService.updateKidsProtectionStatus(data)
        .then((response) => {
            this.$toast.success(response.data.respones_msg);
            $('#kidsAppProtectionPopup').collapse('hide');
            setTimeout(() => {
                this.getKidsList();
            }, 3000);
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    formatDateTime(datetime) {
      if (!datetime) return '';

      const date = new Date(datetime);

      const datePart = date.toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });

      const timePart = date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });

      return `${datePart} ${timePart}`;
    },
    toggleMap() {
        this.showMap = (this.showMap == true) ? false : true;
        KidsService.updateDevice({ _id: this.currentProfile.deviceDetail._id, enableLocationMapDisplay: this.showMap  })
        .then((response) => {
        }).catch((e) => {
            this.isDisabled =false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },

    async getSubscriptionStatus() {
        await UserService.getSubscriptionStatus()
            .then((response) => {
                //this.subscriptionWarnings = response.data.data || [];
            })
            .catch((e) => {
                // Silent fail — don't block the page if this call fails
                console.error("Subscription status check failed:", e);
            });
    },

    async renewSubscription(subscriptionId) {
        this.renewingSubscriptionId = subscriptionId;
        await UserService.renewSubscription({ subscriptionId })
            .then((response) => {
                const action = response.data.data?.action;

                if (action === "paid" || action === "new_subscription" || action === "synced") {
                    this.$toast.success(response.data.respones_msg);
                    // Refresh warnings — subscription may now be resolved
                    this.getSubscriptionStatus();
                } else if (action === "requires_payment_method") {
                    this.$toast.error(response.data.respones_msg);
                    // Redirect to payment history where they can update card
                    this.$router.push({ path: '/payment-methods' });
                } else {
                    // unknown state
                    this.$toast.error(response.data.respones_msg);
                }
            })
            .catch((e) => {
                if (e.response) {
                    this.$toast.error(e.response.data.respones_msg);
                } else {
                    this.$toast.error("Network error. Please try again.");
                }
            })
            .finally(() => {
                this.renewingSubscriptionId = null;
            });
    },

    fetchLatestLocation() {
        if (!this.currentProfile?.deviceDetail?.wifiConnected) {
            this.$toast.error("Device is offline. Cannot fetch location.");
            return;
        }
        this.fetchingLocation = true;
        // Replace with your actual API call
        KidsService.fetchLatestLocation({
            serialNumber: this.currentProfile.deviceDetail.serialNumber,
            profileId: this.currentProfile._id,
        })
        .then(() => {
            this.$toast.success("Location updated");
            this.getKidsList();
        })
        .catch(() => {
            this.$toast.error("Failed to fetch location");
        })
        .finally(() => {
            this.fetchingLocation = false;
        });
    },

    async getRecentLocations() {
        if (!this.currentProfile?.deviceDetail?.serialNumber) return;
        this.locationHistoryLoading = true;
        await DeviceService.getRecentLocations({
            serialNumber: this.currentProfile.deviceDetail.serialNumber,
        })
        .then((response) => {
            this.locationHistory = response.data.data.map(loc => ({
                address: loc.address || `${loc.latitude}, ${loc.longitude}`,
                time: loc.timeAgo,
                latitude: loc.latitude,
                longitude: loc.longitude,
            }));
        })
        .catch((e) => {
            console.error('Failed to fetch recent locations:', e);
        })
        .finally(() => {
            this.locationHistoryLoading = false;
        });
    },
    openHistoryLocation(entry) {
        // Pan map to this location — for now just open Google Maps
        window.open(`https://www.google.com/maps?q=${entry.latitude},${entry.longitude}`, '_blank');
    },
  },
  watch: {
    filterType() {
        this.getCategoryStackedChart();  
        this.getMostUsedCategory();  
        this.getDeviceProfileMostUsedApplicationList();
    },
  },
  beforeMount() {
    this.getKidsList();
    this.selectedDate = this.formatDateForInput(this.currentDate);
    if (window.Android && typeof Android.sendData === "function") {
        Android.sendData(localStorage.getItem('token'));
    } else {
        console.log("Android interface is not available");
    }

    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iosHandler) {
        window.webkit.messageHandlers.iosHandler.postMessage(localStorage.getItem('token'));
    } else {
        console.log("iOS interface is not available");
    }

  },
   created() {
    this.hideGoogleLogin = localStorage.getItem('hideGoogleLogin') === 'true';
  },
    mounted() {
        // Socket is handled by setupSocket() called from getKidsList()
        // Only handle browser online/offline events here

        window.addEventListener('offline', () => {
            this.showNoInternet = true;
        });

        window.addEventListener('online', () => {
            this.showNoInternet = false;
            this.getKidsList();
        });
    },
  beforeDestroy() {
    if (this.socket) {
      this.socket.disconnect();
    }
  },
}
</script>

<style scoped>
.alert {
    font-size: 12px;
    padding: .50rem 1rem;
}

.subscription-warning-card {
    background: linear-gradient(135deg, #fff5f5 0%, #ffe8e8 100%);
    border: 1px solid #ffcdd2;
    border-left: 4px solid #e53935;
    border-radius: 12px;
    padding: 14px 16px;
    box-shadow: 0 2px 8px rgba(229, 57, 53, 0.1);
}

.subscription-warning-icon {
    background: #e53935;
    color: white;
    border-radius: 50%;
    width: 22px;
    height: 22px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    margin-right: 8px;
    flex-shrink: 0;
}

.subscription-warning-title {
    font-size: 14px;
    font-weight: 700;
    color: #c62828;
}

.subscription-warning-badge {
    background: #ffcdd2;
    color: #c62828;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 20px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
}

.subscription-warning-body {
    padding-left: 30px;
}

.subscription-warning-device {
    font-size: 12px;
    color: #555;
    margin-bottom: 2px;
}

.subscription-warning-device-icon {
    color: #e53935;
    margin-right: 4px;
}

.subscription-warning-serial {
    color: #888;
    margin-left: 6px;
}

.subscription-warning-expiry {
    font-size: 12px;
    color: #888;
    margin-bottom: 10px;
}

.subscription-warning-expiry i {
    margin-right: 4px;
}

.subscription-warning-message {
    background: rgba(229, 57, 53, 0.08);
    border-radius: 8px;
    padding: 8px 10px;
    margin-bottom: 12px;
    font-size: 12px;
    color: #c62828;
    line-height: 1.5;
}

.subscription-warning-message i {
    margin-right: 6px;
}

.subscription-warning-btn {
    background: linear-gradient(135deg, #e53935, #c62828);
    color: white;
    border: none;
    border-radius: 20px;
    padding: 8px 24px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 2px 6px rgba(229, 57, 53, 0.4);
    width: 100%;
    transition: opacity 0.2s;
}

.subscription-warning-btn:hover {
    opacity: 0.9;
}

.subscription-warning-btn--loading {
    opacity: 0.7;
    cursor: not-allowed;
}

.subscription-warning-btn:disabled {
    cursor: not-allowed;
}

.camera-icon {
  font-size: 16px;
  cursor: pointer;
  color: #333;
}

.camera-icon:hover {
  color: #007bff;
}

.camera-icon.disabled {
  color: #bbb;
  cursor: not-allowed;
  pointer-events: none;
}

.date-picker-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 44px;
    min-height: 44px;
    cursor: pointer;
}

.date-picker-label {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    margin: 0;
    cursor: pointer;
    z-index: 1;
}

.calendar-icon {
    font-size: 18px;
    color: #333;
    pointer-events: none;
}

.date-picker-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 10;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

.date-picker-input::-webkit-calendar-picker-indicator {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    opacity: 0;
    cursor: pointer;
}

/* Ensure input is accessible on all devices */
.date-picker-input::-webkit-date-and-time-value {
    text-align: left;
}

/* Mobile specific enhancements */
@media (max-width: 768px) {
    .date-picker-wrapper {
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
        touch-action: manipulation;
    }
    
    .date-picker-input {
        font-size: 16px; /* Prevents zoom on iOS */
    }
}

/* Disable calendar when week filter is active */
[data-filter-type="Week"] .date-picker-wrapper {
    opacity: 0.3;
    pointer-events: none;
    cursor: not-allowed;
}

[data-filter-type="Week"] .calendar-icon {
    color: #ccc;
}

[data-filter-type="Week"] .date-picker-input {
    pointer-events: none;
    cursor: not-allowed;
}

/* ── Inline Alerts ── */
/* ── Inline Alerts ── */
.inline-alert {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin: 8px 0 4px;
    padding: 10px 12px;
    border-radius: 12px;
    border-left: 3px solid transparent;
    text-align: left;
}

.inline-alert--warning {
    background: #fffbeb;
    border-left-color: #f59e0b;
    color: #78350f;
}

.inline-alert__icon {
    flex-shrink: 0;
    margin-top: 1px;
    color: #f59e0b;
    display: flex;
    align-items: center;
}

.inline-alert__body {
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 0;
    flex: 1;
    text-align: left;
}

.inline-alert__title {
    font-size: 13px;
    font-weight: 600;
    color: #92400e;
    line-height: 1.3;
    text-align: left;
}

.inline-alert__msg {
    font-size: 12px;
    color: #78350f;
    line-height: 1.4;
    text-align: left;
}

.inline-alert__msg a {
    color: #b45309;
    font-weight: 600;
    text-decoration: underline;
}

.inline-alert__close {
    flex-shrink: 0;
    background: none;
    border: none;
    padding: 2px;
    margin-top: 1px;
    cursor: pointer;
    color: #b45309;
    opacity: 0.6;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    -webkit-tap-highlight-color: transparent;
}

.inline-alert__close:active {
    opacity: 1;
    background: rgba(180, 83, 9, 0.1);
}


/* ── Kid Card ── */
.kid-card {
    background: #fff;
    border-radius: 14px;
    border: 0.5px solid #e5e7eb;
    padding: 14px 14px 12px;
    margin: 8px 0;
    width: 100%; 
}

.kid-card__header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 14px;
}

.kid-card__avatar {
    flex-shrink: 0;
}

.kid-card__info {
    flex: 1;
    min-width: 0;
}

.kid-card__name-row {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: nowrap;
}

.kid-card__name {
    font-size: 15px;
    font-weight: 600;
    color: #111;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 4px;
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.kid-card__meta {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
}

.kid-card__edit {
    color: #6b7280;
    display: flex;
    align-items: center;
    padding: 4px;
    flex-shrink: 0;
}

.kid-card__edit:hover {
    color: #111;
}

.kid-card__version-row {
    display: flex;
    align-items: center;
}

.kid-card__version {
    font-size: 11px;
    font-weight: 500;
    color: #6b7280;
    background: #f3f4f6;
    padding: 2px 7px;
    border-radius: 20px;
    white-space: nowrap;
}
.kid-card__warning {
    display: flex;
    align-items: center;
}


/* ── Action Pills ── */
.kid-card__actions {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
}

.kid-action-pill {
    background: #f9fafb;
    border: 0.5px solid #e5e7eb;
    border-radius: 12px;
    padding: 10px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    transition: background 0.15s;
}

.kid-action-pill:active {
    background: #f0f0f0;
}

.kid-action-pill--disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

.kid-action-pill__link {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    text-decoration: none;
    width: 100%;
}

.kid-action-pill__icon {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #e5e7eb;
    color: #6b7280;
}

.kid-action-pill__icon--active {
    background: #dbeafe;
    color: #1d4ed8;
}

.kid-action-pill__icon--off {
    background: #f3f4f6;
    color: #9ca3af;
}

.kid-action-pill__icon--warning {
    background: #fef3c7;
    color: #d97706;
}

.kid-action-pill__icon--danger {
    background: #fee2e2;
    color: #dc2626;
}

.kid-action-pill__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    width: 100%;
}

.kid-action-pill__label {
    font-size: 11px;
    font-weight: 500;
    color: #374151;
    text-align: center;
}

.kid-action-pill__status {
    font-size: 10px;
    font-weight: 600;
    text-align: center;
}

.kid-action-pill__status--on {
    color: #16a34a;
}

.kid-action-pill__status--off {
    color: #9ca3af;
}

/* ── Sleep toggle inside pill ── */
.kid-action-switch {
    position: relative;
    display: inline-flex;
    width: 30px;
    height: 16px;
    cursor: pointer;
    margin: 0;
}

.kid-action-switch input {
    opacity: 0;
    width: 0;
    height: 0;
    position: absolute;
}

.kid-action-switch__track {
    position: absolute;
    inset: 0;
    background: #d1d5db;
    border-radius: 999px;
    transition: background 0.2s;
}

.kid-action-switch__track::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 12px;
    height: 12px;
    background: white;
    border-radius: 50%;
    transition: transform 0.2s;
}

.kid-action-switch input:checked + .kid-action-switch__track {
    background: #2563eb;
}

.kid-action-switch input:checked + .kid-action-switch__track::after {
    transform: translateX(14px);
}

/* ── Location Card ── */
.location-card {
    background: #fff;
    border-radius: 14px;
    border: 0.5px solid #e5e7eb;
    margin: 8px 0;
    overflow: hidden;
    width: 100%;
}

.location-card__header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 13px 14px;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    user-select: none;
}

.location-card__header:active {
    background: #f9fafb;
}

.location-card__icon {
    width: 34px;
    height: 34px;
    border-radius: 9px;
    background: #dbeafe;
    color: #1d4ed8;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.location-card__info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.location-card__label {
    font-size: 11px;
    font-weight: 500;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.4px;
}

.location-card__coords {
    font-size: 13px;
    font-weight: 600;
    color: #1d4ed8;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.location-card__chevron {
    color: #9ca3af;
    transition: transform 0.2s ease;
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.location-card__chevron--open {
    transform: rotate(180deg);
}

.location-card__body {
    border-top: 0.5px solid #e5e7eb;
    padding: 12px 14px 14px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.location-card__timestamp {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    font-weight: 500;
    color: #0284c7;
}

.location-card__map {
    border-radius: 10px;
    overflow: hidden;
    border: 0.5px solid #e5e7eb;
}

/* ── Activity Header ── */
.activity-header {
    padding: 14px 0 4px;
}

.activity-header__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.activity-header__title {
    font-size: 16px;
    font-weight: 700;
    color: #111;
    margin: 0;
}

.activity-header__toggle {
    display: flex;
    background: #f3f4f6;
    border-radius: 10px;
    padding: 3px;
    gap: 2px;
}

.activity-toggle-btn {
    border: none;
    background: transparent;
    font-size: 13px;
    font-weight: 500;
    color: #6b7280;
    padding: 5px 16px;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
    -webkit-tap-highlight-color: transparent;
}

.activity-toggle-btn--active {
    background: #fff;
    color: #111;
    font-weight: 600;
    box-shadow: 0 1px 3px rgba(0,0,0,0.08);
}

/* ── Date Navigator ── */
.activity-nav {
    display: flex;
    align-items: center;
    background: #fff;
    border: 0.5px solid #e5e7eb;
    border-radius: 12px;
    padding: 4px 6px;
    gap: 4px;
}

.activity-nav__arrow {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    border-radius: 8px;
    color: #374151;
    cursor: pointer;
    flex-shrink: 0;
    -webkit-tap-highlight-color: transparent;
}

.activity-nav__arrow:active {
    background: #f3f4f6;
}

.activity-nav__date {
    flex: 1;
    text-align: center;
    font-size: 13px;
    font-weight: 600;
    color: #111;
}

.activity-nav__cal {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #374151;
}

/* ── Disable calendar in week mode ── */
[data-filter-type="Week"] .activity-nav__cal {
    opacity: 0.3;
    pointer-events: none;
}

/* ── Screen Time Card ── */
.screentime-card {
    background: #fff;
    border-radius: 14px;
    border: 0.5px solid #e5e7eb;
    margin: 8px 0;
    overflow: hidden;
}

.screentime-card__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 14px 10px;
    border-bottom: 0.5px solid #f3f4f6;
}

.screentime-card__left {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.screentime-card__label {
    font-size: 11px;
    font-weight: 500;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.4px;
}

.screentime-card__value {
    font-size: 22px;
    font-weight: 700;
    color: #1d4ed8;
    line-height: 1.1;
}

.screentime-card__info-btn {
    display: flex;
    align-items: center;
    gap: 5px;
    background: #eff6ff;
    border: 0.5px solid #bfdbfe;
    border-radius: 20px;
    padding: 6px 12px;
    font-size: 12px;
    font-weight: 500;
    color: #1d4ed8;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}

.screentime-card__info-btn:active {
    background: #dbeafe;
}

.screentime-card__body {
    padding: 12px 14px 14px;
}

.screentime-card__empty {
    display: flex;
    justify-content: center;
    padding: 8px 0;
}

.screentime-card__empty img {
    max-width: 100%;
    height: auto;
}
/* ── Activity Section wrapper ── */
.activity-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
}

/* ── Apps Card ── */
.apps-card {
    background: #fff;
    border-radius: 14px;
    border: 0.5px solid #e5e7eb;
    margin: 8px 0;
    overflow: hidden;
    width: 100%;
}

.apps-card__header {
    padding: 14px 16px 12px;
    border-bottom: 0.5px solid #f3f4f6;
    text-align: center;
}

.apps-card__title {
    font-size: 14px;
    font-weight: 700;
    color: #111;
}

/* ── App Row ── */
.app-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    border-bottom: 0.5px solid #f3f4f6;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}

.app-row:last-of-type {
    border-bottom: none;
}

.app-row:active {
    background: #f9fafb;
}

.app-row__icon {
    flex-shrink: 0;
}

.app-row__icon-fallback {
    width: 42px;
    height: 42px;
    border-radius: 12px;
    background: #f3f4f6;
    color: #9ca3af;
    display: flex;
    align-items: center;
    justify-content: center;
}

.app-row__info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

/* Name + time on one row */
.app-row__top {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
}

.app-row__name {
    font-size: 13px;
    font-weight: 500;
    color: #111;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
}

.app-row__time {
    font-size: 12px;
    font-weight: 500;
    color: #6b7280;
    white-space: nowrap;
    flex-shrink: 0;
}

.app-row__badge {
    font-size: 10px;
    font-weight: 600;
    background: #fee2e2;
    color: #dc2626;
    padding: 2px 6px;
    border-radius: 20px;
    white-space: nowrap;
    flex-shrink: 0;
}

/* Progress bar */
.app-row__progress-track {
    height: 4px;
    background: #f3f4f6;
    border-radius: 999px;
    overflow: hidden;
    width: 100%;
}

.app-row__progress-track--empty {
    background: #f3f4f6;
}

.app-row__progress-fill {
    height: 100%;
    background: #2563eb;
    border-radius: 999px;
    transition: width 0.3s ease;
    min-width: 4px;
}

.app-row__progress-fill--danger {
    background: #dc2626;
}

.app-row__chevron {
    flex-shrink: 0;
    color: #d1d5db;
}

/* ── Footer ── */
.apps-card__footer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    padding: 10px 14px;
    border-top: 0.5px solid #f3f4f6;
}

.apps-card__footer-btn {
    display: flex;
    align-items: center;
    gap: 4px;
    background: none;
    border: none;
    font-size: 13px;
    font-weight: 600;
    color: #2563eb;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 8px;
    -webkit-tap-highlight-color: transparent;
}

.apps-card__footer-btn:active {
    background: #eff6ff;
}

/* ── Empty state ── */
.apps-card__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 28px 14px;
    color: #9ca3af;
    font-size: 13px;
}
/* ── Last Updated ── */
.last-updated {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding: 12px 0 16px;
    font-size: 12px;
    color: #9ca3af;
}

/* ── Edit Panel ── */
.edit-panel {
    background: #fff;
    border-radius: 14px;
    border: 0.5px solid #e5e7eb;
    margin: 8px 0;
    overflow: hidden;
}

.edit-panel__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px 12px;
    border-bottom: 0.5px solid #f3f4f6;
}

.edit-panel__title {
    font-size: 14px;
    font-weight: 700;
    color: #111;
}

.edit-panel__close {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f3f4f6;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #374151;
    -webkit-tap-highlight-color: transparent;
}

.edit-panel__close:active {
    background: #e5e7eb;
}

/* ── Photo Section ── */
.edit-panel__photo-section {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 16px 16px 12px;
    border-bottom: 0.5px solid #f3f4f6;
}

.edit-panel__avatar {
    position: relative;
    width: 64px;
    height: 64px;
    flex-shrink: 0;
}

.edit-panel__avatar-img {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    object-fit: cover;
    display: block;
}

.edit-panel__avatar-placeholder {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: #f3f4f6;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #9ca3af;
}

.edit-panel__avatar-overlay {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 24px;
    height: 24px;
    background: #2563eb;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: 2px solid #fff;
}

.edit-panel__photo-hint {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.edit-panel__photo-label {
    font-size: 13px;
    font-weight: 600;
    color: #111;
}

.edit-panel__photo-btn {
    font-size: 12px;
    font-weight: 500;
    color: #2563eb;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}

/* ── Fields ── */
.edit-panel__fields {
    padding: 12px 16px;
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.edit-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.edit-field__label {
    font-size: 12px;
    font-weight: 600;
    color: #374151;
    text-align: left;
}

.edit-field__input {
    width: 100%;
    height: 42px;
    border: 0.5px solid #e5e7eb;
    border-radius: 10px;
    padding: 0 12px;
    font-size: 14px;
    color: #111;
    background: #fafafa;
    outline: none;
    -webkit-appearance: none;
    appearance: none;
    box-sizing: border-box;
}

.edit-field__input:focus {
    border-color: #2563eb;
    background: #fff;
}

.edit-field__select-wrap {
    position: relative;
}

.edit-field__select-wrap select.edit-field__input {
    padding-right: 32px;
}

.edit-field__select-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #6b7280;
    pointer-events: none;
}

/* ── Footer / Save ── */
.edit-panel__footer {
    padding: 4px 16px 16px;
}

.edit-panel__save-btn {
    width: 100%;
    height: 44px;
    background: #2563eb;
    color: #fff;
    border: none;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    transition: opacity 0.15s;
}

.edit-panel__save-btn:active {
    opacity: 0.85;
}

.edit-panel__save-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* ── Location card action buttons ── */
.location-card__actions-row {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
}

.location-card__action-btn {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 0.5px solid #e5e7eb;
    background: #f9fafb;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #374151;
    text-decoration: none;
    -webkit-tap-highlight-color: transparent;
    transition: background 0.15s;
    flex-shrink: 0;
}

.location-card__action-btn:active { background: #f3f4f6; }

.location-card__action-btn:disabled {
    opacity: 0.35;
    cursor: not-allowed;
}

.location-card__action-btn--loading {
    background: #eff6ff;
    border-color: #bfdbfe;
    color: #2563eb;
}

@keyframes spin {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
}

.location-card__spin {
    animation: spin 0.8s linear infinite;
    transform-origin: center;
}

/* ── Location meta (time + address) ── */
.location-card__meta {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.location-card__address {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    color: #374151;
    font-weight: 500;
}

/* ── Location history ── */
.location-history {
    border-top: 0.5px solid #f3f4f6;
    padding-top: 14px;
    text-align: left;
}

.location-history__header {
    margin-bottom: 12px;
}

.location-history__title {
    font-size: 11px;
    font-weight: 700;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.6px;
}

.location-history__list {
    display: flex;
    flex-direction: column;
    gap: 0;
}

.location-history__item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    -webkit-tap-highlight-color: transparent;
}

.location-history__dot-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    padding-top: 3px;
}

.location-history__dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #e5e7eb;
    border: 2px solid #d1d5db;
    flex-shrink: 0;
}

.location-history__dot--active {
    background: #2563eb;
    border-color: #2563eb;
    box-shadow: 0 0 0 3px #dbeafe;
}

.location-history__line {
    width: 1.5px;
    flex: 1;
    min-height: 28px;
    background: #e5e7eb;
    margin: 3px 0;
}

.location-history__info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding-bottom: 16px;
}

.location-history__addr {
    font-size: 13px;
    font-weight: 600;
    color: #111;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.location-history__time {
    font-size: 11px;
    color: #9ca3af;
    font-weight: 400;
}

.location-history__map-link {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: #f3f4f6;
    border: 0.5px solid #e5e7eb;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6b7280;
    text-decoration: none;
    flex-shrink: 0;
    margin-top: 1px;
    -webkit-tap-highlight-color: transparent;
}

.location-history__map-link:active {
    background: #e5e7eb;
    color: #111;
}

.location-history__view-all {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    width: 100%;
    padding: 10px 0 2px;
    background: none;
    border: none;
    border-top: 0.5px solid #f3f4f6;
    font-size: 13px;
    font-weight: 600;
    color: #2563eb;
    cursor: pointer;
    margin-top: 4px;
    -webkit-tap-highlight-color: transparent;
}

.location-history__view-all:active { opacity: 0.7; }

.location-history__toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: none;
    border: none;
    padding: 0 0 12px;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}

.location-history__toggle:active { opacity: 0.7; }
button:focus {
    outline: unset;
}

.location-history__loader {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 0;
    font-size: 12px;
    color: #6b7280;
}

.location-history__empty {
    font-size: 12px;
    color: #9ca3af;
    padding: 10px 0 14px;
    text-align: center;
}
</style>